import { render } from "./MInfoField.vue?vue&type=template&id=40f5cb97"
import script from "./MInfoField.vue?vue&type=script&lang=ts"
export * from "./MInfoField.vue?vue&type=script&lang=ts"
script.render = render

export default script